import { useCallback, useEffect, useRef, useState } from 'react';

const useAddToBasket = ({ onAdded } = {}) => {
  const [status, setStatus] = useState('default');
  const [isSuccessVisible, setIsSuccessVisible] = useState(false);
  const timersRef = useRef([]);

  const addToBasket = useCallback(
    (sku) => {
      if (!sku) return;

      if (typeof window.ajaxAddToBasketSimpleAjx !== 'function') {
        setStatus('error');
        const errorTimer = window.setTimeout(() => {
          setStatus('default');
        }, 2500);
        timersRef.current.push(errorTimer);
        return;
      }

      window.ajaxAddToBasketSimpleAjx(sku, 1);
      setStatus('validation');
      setIsSuccessVisible(true);
      onAdded?.();

      const hideSuccessTimer = window.setTimeout(() => {
        setIsSuccessVisible(false);
        const resetTimer = window.setTimeout(() => {
          setStatus('default');
        }, 500);
        timersRef.current.push(resetTimer);
      }, 3000);

      timersRef.current.push(hideSuccessTimer);
    },
    [onAdded]
  );

  useEffect(() => {
    return () => {
      timersRef.current.forEach((id) => window.clearTimeout(id));
      timersRef.current = [];
    };
  }, []);

  return {
    status,
    isSuccessVisible,
    addToBasket
  };
};

export default useAddToBasket;
